export class MechanicalDeficiencyLayout {
	public fields = [
		{ fieldName: 'deficiencyName', label: 'Name' },
		{ fieldName: 'deficiencyType', label: 'Type' },
		{ fieldName: 'mechanicalDeficiencySeverity', label: 'Severity' },
		{ fieldName: 'descriptionMechanicalDeficiency', label: 'Description' },
		{ fieldName: 'deficiencyRemediationType', label: 'Remediation Type' }
	];
}
